import { Panel } from "primereact/panel";
import { Fragment, useEffect, useState } from "react";
import { ASSUMPTION_CONSTANTS } from "../investment_constants";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { NumericFormat } from "react-number-format";
import { useMediaQuery } from "react-responsive";
const permits = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ];
const Assumptions = ({handleAssumptionsSave, handleAssumptionsInputChange, handleInputChange,  assumptionsInput}) => {
    const [isPermit, setIsPermit] = useState(false);
    const amortizationYears = [
        { name: "15 Years", code: 15 },
        { name: "30 Years", code: 30 },
        { name: "40 Years", code: 40 }
    ]; 
    const minValue = 0;
    const maxValue = 100;
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1224px)",
      });
    useEffect(() => {
        if(assumptionsInput?.cap == "Yes")
            setIsPermit(true);
    });

    const renderFooter = () => {
        return (
            <div>
                <div className="grid">
                    <div className="col-6">
                        <Button
                            label="Save"
                            className="p-button-raised p-button-warning p-button-lg"
                            onClick={() => handleAssumptionsSave()}
                        />
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Panel className="Assumptions">
                <div className={`mb-2`}>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4 mt-3">
                            <label className="">
                                Percentage Down
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="percentageDown"
                                        suffix=" %"
                                        decimalScale={2}
                                       
                                        isAllowed={(values) => {
                                            const { floatValue } = values;
                                            return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                          }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("percentageDown", values);
                                        }}
                                        value={assumptionsInput?.percentageDown}
                                        // value={leftContentassumptionsInput?.purchasePrice ? FormatAmount(leftContentassumptionsInput?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">
                                Interest Rate
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="interestRate"
                                        suffix=" %"
                                        decimalScale={2}
                                       
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("interestRate", values);
                                        }}
                                        value={assumptionsInput?.interestRate}
                                        // value={leftContentassumptionsInput?.purchasePrice ? FormatAmount(leftContentassumptionsInput?.purchasePrice) : 0}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Property Tax Rate</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="propertyTaxRate"
                                        suffix=" %"
                                        decimalScale={2}
                                        
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("propertyTaxRate", values);
                                        }}
                                        value={assumptionsInput?.propertyTaxRate}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Amortization</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <Dropdown
                                    className="vw-dropdown vw-dropdown-with-border"
                                    value={assumptionsInput?.amortization}
                                    options={amortizationYears}
                                    required={true}
                                    name="amortization"
                                   
                                      onChange={(val) => {
                                        handleInputChange("amortization", val);
                                       
                                    }}
                                    optionLabel="name"
                                    optionValue="code"
                                />
                                    {/* <InputNumber
                                        className="vw-inputnumber-with-border"
                                        autoComplete="off"
                                        required={true}
                                        name="amortization"
                                        prefix=""
                                        maxFractionDigits={0}
                                        disabled={false}
                                        onValueChange={
                                            handleAssumptionsInputChange
                                        }
                                        value={assumptionsInput?.amortization}
                                    /> */}
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Property Management Fees</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="propertyManagementFees"
                                        suffix=" %"
                                        
                                        decimalScale={2}
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("propertyManagementFees", values);
                                        }}
                                        value={assumptionsInput?.propertyManagementFees}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Vacancy Factor</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="vacancyFactor"
                                        suffix=" %"
                                        decimalScale={2}
                                       
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("vacancyFactor", values);
                                        }}
                                        value={assumptionsInput?.vacancyFactor}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Maintenance</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="maintenance"
                                        suffix=" %"
                                        decimalScale={2}
                                       
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("maintenance", values);
                                        }}
                                        value={assumptionsInput?.maintenance}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Rental Increase</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="rentalIncrease"
                                        suffix=" %"
                                        decimalScale={2}
                                        
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("rentalIncrease", values);
                                        }}
                                        value={assumptionsInput?.rentalIncrease}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Average Appreciation</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="appreciation"
                                        suffix=" %"
                                        decimalScale={2}
                                        
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("appreciation", values);
                                        }}
                                        value={assumptionsInput?.appreciation}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Increase in Property Taxes</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="increaseInPTax"
                                        suffix=" %"
                                        decimalScale={2}
                                        
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("increaseInPTax", values);
                                        }}
                                        value={assumptionsInput?.increaseInPTax}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Inflation Rate
                            </label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="inflationRate"
                                        suffix=" %"
                                        decimalScale={2}
                                       
                                        isAllowed={(values) => {
                                        const { floatValue } = values;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("inflationRate", values);
                                        }}
                                        value={assumptionsInput?.inflationRate}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Cap</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                <span className="p-float-label">
                                    <Dropdown
                                    className="vw-dropdown zipcode-dropdown"
                                    value={assumptionsInput?.cap}
                                    options={permits}
                                    required={true}
                                    name="cap"
                                    onChange={(val) => {
                                        handleAssumptionsInputChange("cap", val);
                                        if(val.target.value == "Yes") {
                                            setIsPermit(true);
                                        } else {
                                            setIsPermit(false);
                                        }
                                    }}
                                    optionLabel="name"
                                    optionValue="name"
                                    style={{
                                        border: "1px solid #ced4da", // Customize the border color and width
                                        borderRadius: "3px", // Optional: round the corners
                                        padding: "5px", // Optional: add padding for spacing
                                    }}
                                    // placeholder="Select a Country"
                                    />
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    {isPermit && (
                        <Fragment>
                        {/* Permit Number */}
                        <div className="grid">
                            <div className="col-12 md:col-12 lg:col-4">
                                <label className="mt-3">Cap Rate
                                </label>
                            </div>
                            <div className="col-12 md:col-12 lg:col-8">
                                <div className="field">
                                    <div className="p-inputgroup">
                                    <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="cap_rate"
                                        suffix=" %"
                                        decimalScale={2}
                                       
                                        isAllowed={(val) => {
                                        const { floatValue } = val;
                                        return floatValue === undefined || (floatValue >= minValue && floatValue <= maxValue);
                                        }}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("cap_rate", values);
                                        }}
                                        value={assumptionsInput?.cap_rate}
                                    />
                                    </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </Fragment>
                    )}
                    <div className="grid">
                    <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3"><strong>Property Information</strong></label>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Built Up</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="builtUp"
                                        prefix=""
                                        decimalScale={2}
                                        disabled={false}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("builtUp", values);
                                        }}
                                        value={assumptionsInput?.builtUp}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12 md:col-12 lg:col-4">
                            <label className="mt-3">Construction Cost</label>
                        </div>
                        <div className="col-12 md:col-12 lg:col-8">
                            <div className="field">
                                <div className="p-inputgroup">
                                    <NumericFormat
                                        className="input-field"
                                        style={{"width":"100%"}}
                                        thousandSeparator=","
                                        autoComplete="off"
                                        required={true}
                                        name="constructionCost"
                                        prefix="$ "
                                        disabled={false}
                                        decimalScale={0}
                                        onBlur={(values) => {
                                            handleAssumptionsInputChange("constructionCost", values);
                                        }}
                                        value={assumptionsInput?.constructionCost}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {renderFooter()}
                </div>
            </Panel>
    )
}

export default Assumptions;